import { axiosMockAdapterInstance as mock } from '../axiosInstance';
import mockDataPeriodFilter from './data/mock-period-filters-api.json';
import envVariables from "../utils/config.json";

const mockGetPeriodFilters = mock
  .onGet(`${process.env.REACT_APP_BASE_URL || envVariables.REACT_APP_BASE_URL}/periodFilter`)
  .reply(function () { return [200, mockDataPeriodFilter.periodList] }
  )

export { mockGetPeriodFilters }